import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';
export const componentKey = "ASSIGN_MEMBER_USERS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setMemberRolesLoadingState: (state, action) =>{
            state.memberRolesLoadingState = action.payload
        },
        setMemberUsersList: (state, action) => {
            state.memberUsersList = action.payload;
        },
        setSelectedMembersUsersList: (state, action) => {
            state.selectedMemberUsersList = action.payload;
        },
        setAssignPayerPaginationState: (state, action) => {
            state.assignPayerPaginationState = { ...state.assignPayerPaginationState, ...action.payload }
        },
        setMemberUserRoles: (state, action) => {
            state.memberUserRoles = action.payload;
        }
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        memberRolesLoadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        memberUsersList: [],
        selectedMemberUsersList: [],
        memberUserRoles: [],

        assignPayerPaginationState: {
            PageNumber: 1,
            PageSize: 10,
            FilterText: "",
            IsDesc: true,
            Skip: 0,
            totalRecords: 10,
        },
    }
});

export const { setMemberUsersList, setSelectedMembersUsersList, setLoadingState, setAssignPayerPaginationState, setMemberUserRoles, setMemberRolesLoadingState } = actions;
